export default interface TipoPinturaVeiculoModel {
    name: string;
    descricao: string;
}

export const tiposPituraVeiculoList: TipoPinturaVeiculoModel[] = [
    { name: "COMUM", descricao: "Comum" },
    { name: "METALICA", descricao: "Metálica" },
    { name: "PEROLIZADA", descricao: "Perolizada" },
]